module.exports = __webpack_public_path__ + "img/check.a54e440d.svg";